import React from 'react'

export default function Tutorial() {
  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center bg-black text-white bg-[url('../public/images/Rx.jpg')] bg-no-repeat bg-contain">
      <h2 className="text-3xl font-bold mb-4">Tutorial</h2>
      <iframe
        className="h-2/3 w-2/3"
        src="https://www.youtube.com/embed/7rW2JNagYYo?si=ZkIE3NBixGNdvHUj"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  )
}
